import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';

export type WalletBalanceData = {
  availableBalance?: number | string;
  totalSpent?: number | string;
  currency?: string;
};

export type CampaignCountData = {
  count?: number;
  totalImpression?: number;
};

export async function fetchWalletBalance() {
  const { data } = await httpClient.get(endpoints.wallet.balance);
  return data as { data?: WalletBalanceData };
}

export async function fetchCampaignCount() {
  const { data } = await httpClient.get(endpoints.dashboard.campaignCount);
  return data as { data?: CampaignCountData };
}
